export default __webpack_public_path__ + "../staticImages/weisswein1-260.png";